export const normalizeFilename = (name: string) => {
  return name
    .replace(/[.]{2,}/g, ".")
    .replace(/[-]{2,}/g, "-")
    .replace(/[_]{2,}/g, "_");
};

export const normalizeFile = (fileObj: File) => {
  const normalizedFile = new File([fileObj], normalizeFilename(fileObj.name), {
    type: fileObj.type,
    lastModified: fileObj.lastModified
  });

  return normalizedFile;
};
